<template>
  <BaseCard>
    <Flex
      v-if="Object.keys(summary).length"
      justify="around"
      :align="$screen === 's' ? 'center' : 'end'"
      wrap
      :direction="$screen === 's' ? 'column' : 'row'"
    >
      <template
        v-for="(item, index) in items"
        :key="index"
      >
        <Stat
          v-if="item.show"
          :value="item.value"
          :text="item.text"
          :sensitive="item.sensitive"
          :currency="item.currency"
          v-test="item.testAttr"
        />
      </template>
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { useI18n } from 'vue-i18n';
import { orderKey } from '@/helpers/compliant-register';
import { useUserStore } from '@/stores/user';
import Stat from './Stat.vue';

const { t } = useI18n();

const { summary } = defineProps<{
  summary: any;
}>();

const items = computed(() => [
  {
    show: hasFeatureFlag('module-customers'),
    value: summary.appointmentCount,
    text: t('customers.appointments'),
    testAttr: 'statsAppointments',
  },
  {
    show: hasFeatureFlag('module-register'),
    value: summary.orderCount,
    text: t(`customers.${orderKey('plural')}`),
    testAttr: 'stats-sales',
  },
  {
    show:
      hasFeatureFlag('module-register') &&
      hasFeatureFlag('customer-loyalty-points'),
    value: summary.loyaltyPoints,
    text: t('customers.loyalty_points'),
    testAttr: 'statsLoyaltyPoints',
  },
  {
    show: hasFeatureFlag('module-appointments'),
    value: summary.cancellationCount,
    text: t('customers.cancellations'),
    testAttr: 'statsCancellations',
  },
  {
    show: hasFeatureFlag('module-appointments'),
    value: summary.noShowCount,
    text: t('customers.no_shows'),
    testAttr: 'statsNoShowCount',
  },
  {
    show: hasFeatureFlag('module-register') && hasFeatureFlag('module-reports'),
    value: summary.totalSpent,
    text: t('customers.total_spent'),
    sensitive: true,
    currency: true,
    testAttr: 'statsTotalSpent',
  },
  {
    show: summary.totalDue,
    value: summary.totalDue,
    text: t('customers.total_due'),
    sensitive: true,
    currency: true,
    testAttr: 'statsTotalDue',
  },
]);

const { hasFeatureFlag } = useUserStore();
</script>
